'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildCompareUrl = exports.buildApplyUrl = exports.buildLearnMoreUrl = exports.isCorporate = exports.processPayloadData = exports.dataMapper = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _actionHandlers;

var _dtmLinkAppend = require('acq-components/lib/utils/DTM/dtmLinkAppend');

var _dtmConsts = require('acq-components/lib/utils/DTM/dtmConsts');

var _actions = require('../actions');

var actions = _interopRequireWildcard(_actions);

var _constants = require('../constants');

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ssrNext = function ssrNext(data) {
  return { action: data };
};

/* to-do: next 2 values will be coming from API */
var DTM_SpeakToSpecialist = 'SpeakToSpecialist';
var DTM_CompareCards = 'CompareCards';

var dataMapper = exports.dataMapper = function dataMapper(_ref) {
  var _ref$next = _ref.next,
      next = _ref$next === undefined ? ssrNext : _ref$next,
      action = _ref.action;

  if (actionHandlers[action.type]) {
    return actionHandlers[action.type]({
      next: next,
      action: action
    });
  }

  // unhandled action
  return next(action);
};

var getDtmNavType = function getDtmNavType(link) {
  var navTypeRaw = link.dtm && link.dtm.eventAction ? link.dtm.eventAction : '';
  return [_dtmConsts.DTM_CONSTS.defaultNavType, _dtmConsts.DTM_CONSTS.intLinkNavType].includes(navTypeRaw) ? navTypeRaw : _dtmConsts.DTM_CONSTS.defaultNavType;
};

var actionHandlers = (_actionHandlers = {}, (0, _defineProperty3.default)(_actionHandlers, actions.PAGE_DATA_RECEIVED, function (_ref2) {
  var action = _ref2.action,
      next = _ref2.next;

  action.payload = processPayloadData(action.payload);
  return next(action);
}), (0, _defineProperty3.default)(_actionHandlers, actions.PAGE_DATA_ERROR, function (_ref3) {
  var action = _ref3.action,
      next = _ref3.next;

  return next(action);
}), _actionHandlers);

var buildLinkNavBase = function buildLinkNavBase(pageDtmInfo) {
  return (pageDtmInfo.country + '-' + pageDtmInfo.primaryCategory + '-' + pageDtmInfo.subCategory1).toLowerCase();
};

var processProductUnits = function processProductUnits(unitList, pageDtmInfo) {
  return unitList.map(function (prodUnit) {
    return (0, _extends3.default)({}, prodUnit, {
      links: (prodUnit.links || []).map(function (link) {
        link.url = (0, _dtmLinkAppend.appendLinkNav)(link.url, getDtmNavType(link), pageDtmInfo.linkNavBase, pageDtmInfo.pageName, prodUnit.dtm ? prodUnit.dtm.productName : undefined, link.dtm && link.dtm.eventAsset ? link.dtm.eventAsset : link.key === 'compare' ? 'compare' : undefined);
        return link;
      })
    });
  });
};

var processPayloadData = exports.processPayloadData = function processPayloadData(payload) {
  var payLoadObj = payload || {};
  var pageDtm = (0, _lodash2.default)(payLoadObj, 'page.dtm') || {};

  var pageDtmInfo = {
    language: pageDtm.language || '',
    businessUnit: pageDtm.businessUnit || 'AMEX',
    primaryCategory: pageDtm.primaryCategory || 'Acq',
    subCategory1: pageDtm.subCategory1 || '',
    subCategory2: pageDtm.subCategory2 || '',
    subCategory3: pageDtm.subCategory3 || '',
    pageName: pageDtm.pageName || '',
    country: pageDtm.country || '',
    pmc: pageDtm.pmc || ''
  };

  pageDtmInfo.linkNavBase = buildLinkNavBase(pageDtmInfo);
  payLoadObj.cards = processProductUnits(payLoadObj.cards || [], pageDtmInfo);
  payLoadObj.products = processProductUnits(payLoadObj.products || [], pageDtmInfo);

  var subNavObj = (0, _lodash2.default)(payLoadObj, 'global.globalHeader.subNav') || {};
  subNavObj.content = (0, _dtmLinkAppend.processSubNavContent)(subNavObj.content, pageDtmInfo.linkNavBase + '-' + pageDtmInfo.subCategory2 + '-' + pageDtmInfo.pageName);

  return (0, _extends3.default)({}, payLoadObj, {
    pageDtmInfo: pageDtmInfo
  });
};

var isCorporate = exports.isCorporate = function isCorporate(shop) {
  return !!_constants.CORPORATE_SHOPS.find(function (s) {
    return s.shopName === shop;
  });
};

var buildUrlByParts = function buildUrlByParts(baseUrl, dataObj, pageDtmInfo) {
  /*
    notes:
    (1) the 3 parts before dataObj.dtmTag.productName is based on the current logic
        on production site (page VAC). The detail is as follows:
      base-part:  us-acq-gcp-sbs 
      subCategory2-part:  'BusinessCards'  (vac sample)
      pageName-part:  'ViewAllCards'  (vac sample)
    (2) the values of thp ortions above all come from API.
  */
  var urlVal = (0, _dtmLinkAppend.appendLinkNav)(baseUrl, dataObj.dtmTag.type, pageDtmInfo.linkNavBase, pageDtmInfo.subCategory2, pageDtmInfo.pageName, dataObj.dtmTag.productName, dataObj.dtmTag.tag);

  return urlVal;
};

var buildLearnMoreUrl = exports.buildLearnMoreUrl = function buildLearnMoreUrl(learnMoreObj, card, pageDtmInfo) {
  var baseUrl = '' + learnMoreObj.url + (card.eep ? '/' + card.eep : '') + '?';
  return buildUrlByParts(baseUrl, learnMoreObj, pageDtmInfo);
};

var buildApplyUrl = exports.buildApplyUrl = function buildApplyUrl(applyObj, card, pageDtmInfo) {
  var baseUrl = '' + applyObj.url + card.eep + applyObj.urlAppend + '?';
  return buildUrlByParts(baseUrl, applyObj, pageDtmInfo);
};

var buildCompareUrl = exports.buildCompareUrl = function buildCompareUrl(pageDtmInfo) {
  return (0, _dtmLinkAppend.appendLinkNav)('/us/credit-cards/business/business-credit-cards/compare-credit-cards?', _dtmConsts.DTM_CONSTS.defaultNavType, pageDtmInfo.linkNavBase, pageDtmInfo.subCategory2, pageDtmInfo.pageName, 'CompareCards');
};